import type { App } from 'vue'
// import { name } from './name'

export const setupGlobCom = (app: App<Element>): void => {
  app
  // app.component('name', comment)
}
